import React, { ReactNode } from "react";
import AssetsProvider from "@insightfulscience/atomic-react/utils/AssetsProvider";

import { publicConfig } from "../../config";

const { SB_CDN_HOST, SB_CDN_BASE_URL } = publicConfig;

const baseAssetsUrl = `${SB_CDN_HOST}${SB_CDN_BASE_URL}/assets`;

type Props = {
	children: ReactNode | ReactNode[];
};

function AssetsBaseUrlProvider({ children }: Props) {
	return (
		<AssetsProvider assetPrefix={baseAssetsUrl}>{children}</AssetsProvider>
	);
}

export default AssetsBaseUrlProvider;
